import React, { useState, useMemo } from "react";
import {
  Grid,
  Card,
  CardHeader,
  CardContent,
  Divider,
  TextField,
  Button,
  Typography,
  makeStyles,
  Chip,
  Box,
} from "@material-ui/core";
import useAgentCreate from "api/useAgentCreate.js";
import notifySuccess from "utils/Toast";
import routes from "routes";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import UrlManagerPopup from "./UrlManagerPopup";

const useStyles = makeStyles((theme) => ({
  root: { padding: theme.spacing(4) },
  dateField: {
    marginTop: theme.spacing(3),
    maxWidth: 300, // Keeps the date picker from being too wide
  },
  saveButton: {
    marginTop: theme.spacing(2),
    backgroundColor: theme.palette.secondary.main,
    color: "white",
    "&:hover": { backgroundColor: theme.palette.secondary.dark },
  },
  footer: {
    marginTop: theme.spacing(2),
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  counterChip: {
    fontWeight: "bold",
    backgroundColor: theme.palette.info.light,
    color: theme.palette.info.contrastText,
  },
}));

function UserAgentForm() {
  const classes = useStyles();
  const [rawInput, setRawInput] = useState("");
  const { saveAgents, isLoading } = useAgentCreate();

  const [updateDate, setUpdateDate] = useState(
    new Date().toISOString().split("T")[0],
  );

  let history = useHistory();

  const duplicates = useMemo(() => {
    //const lines = rawInput.split(/[\n,]+/).map(l => l.trim()).filter(l => l !== "");
    
const lines = rawInput
  .split(/\n+/)   // ONLY split on newline (fix applied)
  .map(l => l.trim())
  .filter(l => l !== "");

    const seen = new Set();
    const dups = new Set();
    
    lines.forEach(line => {
        if (seen.has(line)) dups.add(line);
        seen.add(line);
    });
    return dups;
}, [rawInput]);

  // Live Validation Logic: Extracts unique agents from the text
  const processedAgents = useMemo(() => {
    if (!rawInput.trim()) return [];

    // const list = rawInput
    //   .split(/[\n,]+/)
    //   .map((item) => item.trim())
    //   .filter((item) => item !== "");
    
const list = rawInput
  .split(/\n+/)   // ONLY newline
  .map((item) => item.trim())
  .filter((item) => item !== "");


    return [...new Set(list)]; // Deduplicate
  }, [rawInput]);

  const handleSave = async () => {
    if (processedAgents.length === 0) return;

    // Format into payload array
    const payload = processedAgents.map((agent) => ({
      userAgent: agent,
      updateUADateByBrowser: updateDate,
    }));

    try {
      const result = await saveAgents(payload);
      if (result.status === 200) {
        notifySuccess(
          `${processedAgents.length} User Agents added successfully.`,
        );
        history.push(`${routes.userAgent.path}`);
      }
    } catch (error) {
      console.error("Save failed:", error);
    }
  };

  return (
    <div className={classes.root}>
      <Grid container spacing={4}>
        <Grid item xs={12} md={10} lg={8}>
          <Card>
            <CardHeader
              title="Add User Agents"
              subheader="Paste your list below (comma or newline separated)"
             
            />
            <Divider />
            <CardContent>
              <TextField
                fullWidth
                multiline
                minRows={10}
                variant="outlined"
                placeholder="Paste user agents here..."
                value={rawInput}
                onChange={(e) => setRawInput(e.target.value)}
              />
              {duplicates.size > 0 && (
    <Box sx={{ mt: 2, p: 2, bgcolor: '#fff1f0', border: '1px solid #ffa39e', borderRadius: 1 }}>
        <Typography variant="caption" color="error" sx={{ fontWeight: 'bold' }}>
            Duplicate entries detected (will be merged):
        </Typography>
        {Array.from(duplicates).map((agent, i) => (
            <Typography key={i} variant="caption" display="block" color="error">
                • {agent}
            </Typography>
        ))}
    </Box>
)}
              <TextField
                label="Last Updated Date of Agents"
                type="date"
                variant="outlined"
                className={classes.dateField}
                value={updateDate}
                onChange={(e) => setUpdateDate(e.target.value)}
                InputLabelProps={{ shrink: true }} // Required for type="date"
                fullWidth
              />

              <div className={classes.footer}>
                <div>
                  {processedAgents.length > 0 && (
                    <Chip
                      label={`${processedAgents.length} Unique Agents Detected`}
                      className={classes.counterChip}
                    />
                  )}
                </div>

                <Button
                  variant="contained"
                  className={classes.saveButton}
                  onClick={handleSave}
                  disabled={isLoading || processedAgents.length === 0}
                >
                  {isLoading
                    ? "Saving..."
                    : `Save ${processedAgents.length} Agents`}
                </Button>
              </div>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </div>
  );
}

export default UserAgentForm;
